import React from 'react';
import styles from './CourseItemList.module.css';
import * as utils from '../../../utils/utils';
import Sidebar from '../../Sidebar/Sidebar';

const ITEM_TYPE_ENDPOINT_MAP = {
	skill: '/course/getSkillGapCourseList',
	tool: '/course/getToolGapCourseList',
	domain: '/course/getDomainGapCourseList',
	'soft-skill': '/course/getSoftSkillGapCourseList',
	certificate: '/course/getCertificateGapCourseList',
};

const ITEM_TYPE_TITLE_MAP = {
	skill: 'All Skill Gap Courses',
	tool: 'All Tool Gap Courses',
	domain: 'All Domain Gap Courses',
	'soft-skill': 'All Soft Skill Courses',
	certificate: 'All Certificate Prep Courses',
};

export default class CourseItemList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isLoadingMore: false,
			errorText: '',
			itemType: 'skill',
			courses: [],
			offset: 0,
			limit: 20,
			hasMore: false,
		};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		const itemType = this.getQueryItemType();
		this.setState({ itemType }, () => this.loadCourses(0, false));
	}

	getQueryItemType = () => {
		const params = new URLSearchParams(window.location.search);
		const itemType = params.get('itemType') || 'skill';
		if (ITEM_TYPE_ENDPOINT_MAP[itemType]) {
			return itemType;
		}

		return 'skill';
	};

	getListEndpoint = () => {
		return ITEM_TYPE_ENDPOINT_MAP[this.state.itemType] || ITEM_TYPE_ENDPOINT_MAP.skill;
	};

	loadCourses = (offset, append) => {
		const endpoint = this.getListEndpoint();
		const currentCourses = this.state.courses;

		this.setState({
			isLoading: !append,
			isLoadingMore: append,
			errorText: '',
		}, () => {
			utils.sendRequest(endpoint, { offset })
				.then((responseData) => {
					const nextCourses = responseData.courses || [];
					const nextLimit = responseData.limit || this.state.limit;

					this.setState({
						isLoading: false,
						isLoadingMore: false,
						courses: append ? [...currentCourses, ...nextCourses] : nextCourses,
						offset: offset + nextCourses.length,
						limit: nextLimit,
						hasMore: nextCourses.length === nextLimit,
					});
				})
				.catch((error) => {
					this.setState({
						isLoading: false,
						isLoadingMore: false,
						errorText: error && error.message ? error.message : 'Could not load courses right now.',
					});
				});
		});
	};

	onLoadMoreClick = () => {
		if (this.state.isLoadingMore || !this.state.hasMore) {
			return;
		}

		this.loadCourses(this.state.offset, true);
	};

	onCourseClick = (courseId) => {
		window.location.href = `/course-detail?courseID=${courseId}&chapterNum=1`;
	};

	onBackClick = () => {
		window.location.href = '/my-courses';
	};

	renderCourseCard = (course, index) => {
		return (
			<button
				key={`full-course-${course.courseId}-${index}`}
				type='button'
				className={styles.courseCard}
				onClick={() => this.onCourseClick(course.courseId)}
			>
				<div className={styles.itemPill}>{course.itemName || 'Course Item'}</div>
				<h3 className={styles.courseTitle}>{course.courseTitle || 'Untitled Course'}</h3>
				<p className={styles.courseMeta}>Recommended for {course.jobTitle || 'your role roadmap'}</p>
			</button>
		);
	};

	render() {
		const {
			isLoading,
			isLoadingMore,
			errorText,
			courses,
			hasMore,
			itemType,
		} = this.state;

		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowTop} />
				<div className={styles.glowBottom} />

				<div className={styles.layoutShell}>
					<section className={styles.headerPanel}>
						<div className={styles.brandBadge}>HQVibe</div>
						<h1 className={styles.title}>{ITEM_TYPE_TITLE_MAP[itemType] || 'Course List'}</h1>
						<p className={styles.subtitle}>Browse complete recommendations in this category and open any course to start learning.</p>
						<button type='button' className={styles.secondaryButton} onClick={this.onBackClick}>Back To Categories</button>
					</section>

					<section className={styles.mainCardPanel}>
						<h2 className={styles.formTitle}>Courses</h2>
						<p className={styles.formText}>Each card opens course details from chapter one.</p>

						{
							isLoading
								? <div className={styles.loadingBox}>Loading courses...</div>
								: (
									<div className={styles.listStack}>
										{
											courses.length === 0
												? <p className={styles.emptyText}>No courses found in this category right now.</p>
												: courses.map(this.renderCourseCard)
										}
									</div>
								)
						}

						{
							hasMore && !isLoading &&
							<button type='button' className={styles.primaryButton} onClick={this.onLoadMoreClick} disabled={isLoadingMore}>
								{isLoadingMore ? 'Loading More...' : 'Load More Courses'}
							</button>
						}

						{
							errorText !== '' &&
							<div className={styles.errorBox}>{errorText}</div>
						}
					</section>
				</div>
			</div>
		);
	}
}
